
import AuthMixin from "@/common/mixins/auth.mixin";
import StripeService from "@/services/stripe.service";
import { OfficeDto } from "@/types/office.type";
import { StripePaymentMethodFormDto } from "@/types/stripe.type";
import { Component, Mixins, Prop } from "vue-property-decorator";

@Component
export default class CreateEditPaymentMethodModal extends Mixins(AuthMixin) {
  @Prop({ default: null }) id!: string | null;
  @Prop({ required: true }) office!: OfficeDto;

  loading = true;

  form = new StripePaymentMethodFormDto();
  cardNumber: any;
  cardExpiry: any;
  cardCvc: any;

  get stripeElements() {
    return (this as any).$stripe.elements();
  }

  destroyStripe(): void {
    this.cardNumber.destroy();
    this.cardExpiry.destroy();
    this.cardCvc.destroy();
  }

  mountStripe(): void {
    const style = {
      base: {
        color: '#495057',
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSmoothing: 'antialiased',
        fontSize: '14px',
        '::placeholder': {
          color: '#6c757d',
        }
      },
      invalid: {
        color: '#fa755a',
        iconColor: '#fa755a',
      },
    };

    this.cardNumber = this.stripeElements.create('cardNumber', { style });
    this.cardNumber.mount('#card-number');
    this.cardExpiry = this.stripeElements.create('cardExpiry', { style });
    this.cardExpiry.mount('#card-expiry');
    this.cardCvc = this.stripeElements.create('cardCvc', { style });
    this.cardCvc.mount('#card-cvc');
  }

  async onShown(): Promise<void> {
    this.form = new StripePaymentMethodFormDto();

    if (this.id) {
      this.form = await StripeService.getPaymentMethodForm(this.id);
    }

    this.mountStripe();

    this.loading = false;
  }

  closeModal(): void {
    this.$bvModal.hide("create-edit-payment-method-modal");
  }

  onCancel(): void {
    this.closeModal();
  }

  async submit(): Promise<void> {
    const userInfo = this.userInfo();

    if (!userInfo) {
      return;
    }

    const { token, error } = await (this as any).$stripe.createToken(this.cardNumber);
    const cardErrorElement = document.getElementById('card-error');

    if (error && cardErrorElement) {
      cardErrorElement.innerHTML = error.message;
      return;
    }

    this.form.officeId = this.office.id;
    this.form.cardToken = token.id;
    this.form.email = userInfo.email;

    await StripeService.savePaymentMethod(this.form);

    this.$emit("success");
    this.closeModal();
  }
}
